export default __webpack_public_path__ + "static/media/Element.e3bd559a.png";